import React, {useState} from "react";
import {Outlet} from "react-router-dom";

import Page from "../../layouts/Main/Page";
import TemplatesProvider from "../Templates/TemplatesContext";
import QuotesProvider, {useQuotes} from "./QuotesContext";
import QuotesIndex from "./QuotesTabs/QuotesList";
import QuoteTemplate from "./QuotesTabs/QuoteTemplate";

import Tab from "@mui/material/Tab";
import Tabs from "@mui/material/Tabs";
import {TabContext, TabPanel} from "@mui/lab";
import Box from "@mui/material/Box";


const Quotes = () => {
    return (
        <TemplatesProvider>
            <QuotesProvider>
                <QuotesPage/>
            </QuotesProvider>
        </TemplatesProvider>
    );
}

const QuotesPage = () => {
    const {showQuote} = useQuotes();
    const [selectedTab, setSelectedTab] = useState("0")

    return <>

        <Page title="Preventivi"
              disablePadding
              hidden={showQuote}>
            <TabContext value={selectedTab}>
                <Box sx={{borderBottom: 1, borderColor: 'divider'}}>
                    <Tabs variant="scrollable"
                          aria-label="quotes tabs"
                          value={selectedTab}
                          onChange={(e, newValue) => setSelectedTab(newValue)}>
                        <Tab label="Lista preventivi" value="0"/>
                        <Tab label="Modelli email" value="1"/>
                    </Tabs>
                </Box>
                <TabPanel value="0" sx={{p:0}}><QuotesIndex/></TabPanel>
                <TabPanel value="1" sx={{p:0}}><QuoteTemplate/></TabPanel>
            </TabContext>
        </Page>
        {
            <Outlet/>
        }
    </>
}

export default Quotes;